import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Enrollment, ManageSubscriptionResetState, StoreEnrollmentJourneySerialNumber } from '../../../../actions/MyAccount';
import ErrorPage from '../../../../components/shared/errorPage/ErrorPage';
import PaymentComplete from '../../../../components/PaymentComplete/PaymentComplete';
import Loader from '../../../../components/shared/loader/Loader';
import SubHeader from '../../../../components/shared/subheader/SubHeader';
import { refreshBtn, tryAgainBtn, ECOPROTOKEN_CLAIMS, ONLINE, LOCALSESSIONDATAKEYS } from '../../../../constants/AppConstants';
import './ZuoraPaymentLanding.css';
import { routePath } from '../../../../constants/Routes';
import PaymentSummary from '../../../../components/shared/paymentSummary/paymentSummary';
import { pushDataLayer } from '../../../../constants/AppMethod';
import WebSubHeader from '../../../../components/WebSubHeader/WebSubHeader';
import { useHistory } from 'react-router-dom';
import SubscriptionPayments from '../../../../components/shared/SubscriptionPayments/SubscriptionPayments';
import { fetchDeviceList, resetDeviceList } from '../../../../actions/SelectDevice';
import { getUserSessionData } from '../../../../utils/Authentication/handleUserSession';
import DisplayUpdateAccountConfirmation from '../../../../components/EditMyAccount/DisplayUpdateAccountConfirmation/DisplayUpdateAccountConfirmation';
import deviceOffline from '../../../../assets/images/printer-offline.svg';
import { getLocalSessionData } from '../../../../utils/Authentication/handleUserSession';
import PlannedMaintenance from '../../../../components/PlannedMaintenance/PlannedMaintenance';

const ZuoraPaymentLanding = (props) => {
  const { t } = useTranslation(["translation"]);
  const history = useHistory();
  const dispatch = useDispatch();
  const { location } = props;
  const PAYMENT_OPTION = location?.state?.paymentType;
  const result = useSelector((state) => state.MyAccount);
  const ManageSubscriptionResponse = useSelector(state => state.ManageSubscription);
  const EnrollmentResponse = useSelector(state => state.Enrollment);
  const selectedPlan = useSelector(state => state.MyPlan);
  const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
  const deviceListResult = useSelector((state) => state.SelectDevice);
  const { enrollmentJourneySerialNumber } = useSelector(state => state.EnrollmentSerialNumber);

  useEffect(() => {
    return () => {
      dispatch(ManageSubscriptionResetState());
    }
  }, [dispatch, PAYMENT_OPTION]);

  useEffect(() => {
    if (!ManageSubscriptionResponse.success && deviceListResult?.deviceList?.devices)
      dispatch(resetDeviceList());
    // eslint-disable-next-line  
  }, [])

  const moveToPreviousPage = () => {
    history.push(routePath.ACCOUNT);
  }
  if (ManageSubscriptionResponse.loading || EnrollmentResponse.loading || deviceListResult.loading) {
    return <Loader slowResponse={true}></Loader>
  }
  if (EnrollmentResponse.error) {
    return <ErrorPage errorInfo={EnrollmentResponse.error} showRefreshBtn={refreshBtn.HIDE} showTryAgain={tryAgainBtn.SHOW} to={routePath.SUBSCRIPTION_NETWORK_ERROR_VALIDATION} isMobileSubscriptionError={true}></ErrorPage>
  }
  if (EnrollmentResponse.success) {
    const isDiscountAvailed = (EnrollmentResponse.data?.selectedPlan?.discountPlanIds) ? true : false;
    const planPrice = EnrollmentResponse.data?.selectedPlan?.price;
    const planCurrency = EnrollmentResponse.data?.shippingAddress?.currency;

    // store enrolled serial number in local storage to display "enrollment inprogress" warning
    if (!enrollmentJourneySerialNumber) {
      dispatch(StoreEnrollmentJourneySerialNumber(EnrollmentResponse.data?.serialNumber));
    }

    pushDataLayer('signup', 'status', 'success')
    return <PaymentComplete isDiscountAvailed={isDiscountAvailed} planPrice={planPrice} planCurrency={planCurrency}></PaymentComplete>
  }

  if (ManageSubscriptionResponse.success && deviceListResult?.success) {
    const device_id = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)
    const matchedAddress = deviceListResult?.deviceList?.devices.filter((address) => {
      return (address.deviceId === device_id)
    });
    if (matchedAddress[0]?.networkStatus?.toLowerCase() === ONLINE.toLowerCase()) {
      dispatch(Enrollment(ManageSubscriptionResponse.subscriptionDetails));
    }
    else {
      let backdrop = document.getElementById("mobile-header-left");
      if (backdrop) backdrop.style.display = "none";

      return <DisplayUpdateAccountConfirmation
        updateAddressHeader={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_HEADER")}
        updateAddressInfo={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_INFO")}
        updateAddressBtn={t("ECOPRO_BTNS.RETRY")}
        onUpdateClick={() => dispatch(fetchDeviceList(UID))}
        image={deviceOffline}
      ></DisplayUpdateAccountConfirmation>
    }
  }

  if (ManageSubscriptionResponse.error) {
    return <ErrorPage errorInfo={ManageSubscriptionResponse.error} showRefreshBtn={refreshBtn.HIDE} showTryAgain={tryAgainBtn.SHOW} to={routePath.SUBSCRIPTION_NETWORK_ERROR_VALIDATION} isMobileSubscriptionError={true}></ErrorPage>
  }
  if (ManageSubscriptionResponse.success && !deviceListResult?.loading) {
    dispatch(fetchDeviceList(UID));
  }

  return (
    <div className="mt-40 payment-page-outer-wrapper">
      <SubHeader
        currentStep="4"
        totalStep="4"
        stepName={t("SUB_HEADER.STEP_4.STEP_NAME")}
        stepInfo={t("SUB_HEADER.STEP_4.STEP_INFO")}
        stepInfoSub={t("SUB_HEADER.STEP_4.STEP_INFO_SUB")}
        cname="payment-mobile-step-header"
      />
      <WebSubHeader
        currentStep="4"
        totalStep="4"
        stepName={t('SUB_HEADER.STEP_4.STEP_NAME')}
        stepInfo={t('SUB_HEADER.STEP_4.STEP_INFO')}
        moveToPreviousPage={moveToPreviousPage}
        previousBtnText={t('CUSTOMER_WEB.PAYMENT.ACCOUNT_INFO_BACK_NAV_TEXT')}
        stepInfoSub={t("SUB_HEADER.STEP_4.STEP_INFO_SUB")}
        cname="payment-desktop-step-header"
      />
      <PlannedMaintenance />
      <PaymentSummary planDetails={selectedPlan.selected_plan} goTo={routePath.PLANS} />
      <SubscriptionPayments zrenderData={result.account} />
    </div>
  );
};

export default ZuoraPaymentLanding;